/**
 * Cap/Polo/Sweatshirt/Blackout/Whiteout have no verse-customizer UI —
 * they use Dawn's stock add-to-cart form (buy-buttons.liquid), which
 * never sets the "Garment"/"Color"/"Size" line-item properties the
 * Worker's order webhook requires (see worker/src/shopify.js
 * extractCustomLineItems — a line item with no Garment property is
 * silently filtered out and never reaches Printful, and never fires the
 * Discord alert either). The verse-customizer (Tee/Hoodie) already sets
 * these itself in verse-customizer.js; this covers every OTHER product
 * so all of them go through the exact same order/notification pipeline.
 *
 * Data source: layout/theme.liquid emits a small JSON script tag
 * (#clvry-garment-cart-data) with the product's garment_key metafield,
 * its option names, and each variant's id + option values — enough to
 * resolve Color/Size from whichever variant is currently selected
 * without needing to know the option order in advance (Blackout/
 * Whiteout only have a Size option; Cap/Polo/Sweatshirt have Color+Size).
 */
(function () {
  function init() {
    var dataEl = document.getElementById("clvry-garment-cart-data");
    if (!dataEl) return;
    // Verse-customizer products (Tee/Hoodie) already set these
    // properties themselves via their own richer form — don't double up.
    if (document.querySelector(".vc-root")) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    function ensureHiddenInput(name) {
      var selector = 'input[name="properties[' + name + ']"]';
      var input = form.querySelector(selector);
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + name + "]";
        form.appendChild(input);
      }
      return input;
    }

    // Leading underscore hides these from the customer-facing cart
    // (Dawn's cart-drawer.liquid/main-cart-items.liquid both skip any
    // property whose name starts with "_") — without it, Color/Size
    // duplicate the real Shopify variant options Dawn already shows,
    // and Garment has zero customer value to begin with. Matches the
    // same "_Garment"/"_Color"/"_Size" convention verse-customizer.js
    // uses; worker/src/shopify.js strips the underscore back off for
    // both.
    var garmentInput = ensureHiddenInput("_Garment");
    var colorInput = ensureHiddenInput("_Color");
    var sizeInput = ensureHiddenInput("_Size");

    garmentInput.value = data.garment;

    function syncFromSelectedVariant() {
      var variant = data.variants.filter(function (v) {
        return String(v.id) === String(idInput.value);
      })[0];
      if (!variant) return;

      var byOptionName = {};
      data.optionNames.forEach(function (name, i) {
        byOptionName[name] = variant.options[i];
      });

      colorInput.value = byOptionName["Color"] || "";
      sizeInput.value = byOptionName["Size"] || "";
    }

    syncFromSelectedVariant();

    // Dawn's variant-selects component updates the hidden #id input's
    // .value directly, then dispatches a bubbling "change" Event on it
    // (see product-info.js updateVariantInputs) — this single listener
    // on the form catches that plus any native radio/select change.
    form.addEventListener("change", syncFromSelectedVariant);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
